"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 1.40206C0 0.627724 0.627724 0 1.40206 0H14.5979C15.3723 0 16 0.627724 16 1.40206V10.4742C16 11.2486 15.3723 11.8763 14.5979 11.8763H1.40206C0.627724 11.8763 0 11.2486 0 10.4742V1.40206ZM1.40206 1.40206V10.4742H14.5979V1.40206H1.40206Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.422 4.70113H1.40143V3.29907H15.422V4.70113Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M3.0509 8.70103C3.0509 8.31386 3.36477 8 3.75193 8H4.8241C5.21127 8 5.52513 8.31386 5.52513 8.70103C5.52513 9.0882 5.21127 9.40206 4.8241 9.40206H3.75193C3.36477 9.40206 3.0509 9.0882 3.0509 8.70103Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.34985 8.70103C6.34985 8.31386 6.66372 8 7.05088 8H8.94779C9.33496 8 9.64882 8.31386 9.64882 8.70103C9.64882 9.0882 9.33496 9.40206 8.94779 9.40206H7.05088C6.66372 9.40206 6.34985 9.0882 6.34985 8.70103Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;